module.exports = __webpack_public_path__ + "img/item_bg1.4b76979c.png";